/* eslint-disable */

import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import { useRouter } from "@core/utils/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { GetByCurrentUser } from "@/services/api/DefaultTemplate/RoleService";

import { GetPagingParams } from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";
import { GetTree } from "@/services/api/DefaultTemplate/DonViService";

export default function useDonViService() {
  const toast = useToast();
  const { route, router } = useRouter();

  const roles = ref([]);

  const getRoles = (ctx, callback) => {
    GetByCurrentUser().then((response) => {
      roles.value = response.data;
      // console.log(roles.value);
    });
  };

  const refListTable = ref(null);

  const perPage = ref(10);

  const currentPage = ref(1);

  const perPageOptions = [10, 25, 50, 100];

  const searchQuery = ref("");
  const sortBy = ref("");
  const isSortDirDesc = ref(true);

  //TODO: de dk neu get theo DonVi

  const getDataList = (ctx, callback) => {
    GetPagingParams(ctx).then((response) => {
      if (!response.isError) {
        callback(response.data);
      } else {
        callback(null);
        toast({
          component: ToastificationContent,
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: response.message,
          },
        });
      }
    });
  };

  // const donVis = ref([]);

  const getDonVi = (ctx, callback) => {
    GetTree().then((response) => {
      if (response.data && response.data.length < 1) {
        router.replace("/").then(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error: Go To Home page",
              icon: "AlertTriangleIcon",
              variant: "danger",
              text: "Chức năng bị hạn chế",
            },
          });
        });
      }
      callback(response.data);
    });
  };

  return {
    refListTable,
    perPage,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,

    getDataList,
    getRoles,
    roles,
    getDonVi,
  };
}
